import { tr } from "@/utils/translations";
import SentryAnalytics from "@/_errors/sentry";
import { AnalyticsVendor } from "./v4_analytics";


const impl = new SentryAnalytics();
const vendor: AnalyticsVendor = {
    id: "system:sentry",
    strictlyRequired: false,
    inInitialActivations: true,

    describe: () => ({
        name: tr("cookie-law.vendors.systems.sentry.name"),
        description: tr("cookie-law.vendors.systems.sentry.description"),

        actualFeatures: [3],
        actualSpecialFeatures: [2],
        actualPurposes: [10],
        actualSpecialPurposes: [],

        policyUrl: "/privacy",
        deviceDisclosureUrl: null,
    }),


    build: () => impl
}


export default vendor;
